import { render, staticRenderFns } from "./DataCorrectionAttachments.vue?vue&type=template&id=5ca265e6&scoped=true&"
import script from "./DataCorrectionAttachments.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionAttachments.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionAttachments.vue?vue&type=style&index=0&id=5ca265e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca265e6",
  null
  
)

export default component.exports